"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const LightModeRounded_1 = __importDefault(require("@mui/icons-material/LightModeRounded"));
const BrightnessMediumRounded_1 = __importDefault(require("@mui/icons-material/BrightnessMediumRounded"));
const DarkModeOutlined_1 = __importDefault(require("@mui/icons-material/DarkModeOutlined"));
const ContrastOutlined_1 = __importDefault(require("@mui/icons-material/ContrastOutlined"));
const core_1 = require("companion-app-components/utils/core");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const mixpanelEvents_1 = __importDefault(require("utils/mixpanelEvents"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const appearanceOptions = [
    { value: 'system', label: 'System setting', Icon: BrightnessMediumRounded_1.default },
    { value: 'light', label: 'Light', Icon: LightModeRounded_1.default },
    { value: 'dark', label: 'Dark', Icon: DarkModeOutlined_1.default },
];
const Appearance = () => {
    const { classes } = useStyles();
    const { userPreferences, setUserPreference } = (0, useQPreferences_1.default)();
    const selectedTheme = (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.theme) === 'light' || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.theme) === 'dark' || (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.theme) === 'system'
        ? userPreferences.theme
        : 'system';
    return (<>
      <Box_1.default marginBottom={3}>
        <Typography_1.default id="settings_appearance_page_header" variant="h5" className={classes.headlineText}>
          <ContrastOutlined_1.default className={classes.headlineIcon}/>
          <span>Appearance</span>
        </Typography_1.default>
      </Box_1.default>

      <RendersCount_1.default id="appearance-tab"/>
      <div className={classes.panel}>
        <Typography_1.default variant="subtitle1" className={classes.sectionTitle}>
          Customize how Quicken looks
        </Typography_1.default>

        <ToggleButtonGroup_1.default className={classes.toggleGroup} size="small" value={selectedTheme} exclusive onChange={(_, newTheme) => {
            if (newTheme !== null && newTheme !== selectedTheme) {
                core_1.tracker.track(mixpanelEvents_1.default.settingsAppearance, {
                    action: 'appearance_changed',
                    state: 'profile',
                    appearance_mode: newTheme,
                    previous_mode: selectedTheme,
                });
                setUserPreference({ theme: newTheme });
            }
        }}>
          {appearanceOptions.map(({ value, label, Icon }) => (<ToggleButton_1.default key={value} value={value} className={classes.toggleButton}>
              <Icon />
              {label}
            </ToggleButton_1.default>))}
        </ToggleButtonGroup_1.default>
      </div>
    </>);
};
exports.default = Appearance;
